const Emitter = require('mn-utils/Emitter');
const {
  DEFAULT_SETTINGS,
  apiSettingsGet,
  apiSettingsSet,
  apiSettingsSetAvatar,
} = require('../api/merchant/settings');
const decorateByLoading = require('./utils/decorateByLoading');
const {
  openPopupInfo,
} = require('./popup');
const {
  account$,
} = require('./account');

export function settingsSavedPopup() {
  openPopupInfo(['Settings', 'Settings have been saved']);
}
export const avatarLoading$ = new Emitter();
export const loadingSettingsGet$ = new Emitter();
export const loadingSettingsSet$ = new Emitter();
export const loadingSettings$ = Emitter.some([
  loadingSettingsGet$,
  loadingSettingsSet$,
]);

export const settings$ = new Emitter(() => {
  settingsUpdate();
}, DEFAULT_SETTINGS);

export const settingsUpdate = decorateByLoading(
    apiSettingsGet,
    loadingSettingsGet$,
    settings$.emit,
);

export const settingsChange = decorateByLoading(
    apiSettingsSet,
    loadingSettingsSet$,
    (response, params) => {
      settings$.set(params);
      // cashUpdate();
      settingsSavedPopup();
    },
);

export const disableTfa = decorateByLoading(
    apiSettingsSet,
    loadingSettingsSet$,
    (response, params) => {
      settings$.set(params);
      // cashUpdate();
      openPopupInfo(['You\'ve disabled two-factor authorization']);
    },
);

export const avatarChange = decorateByLoading(
    apiSettingsSetAvatar,
    avatarLoading$,
    (response, params) => {
      account$.set({
        avatar: `/v1/console/avatar?t=${(new Date).getTime()}`,
      });
    },
);
